module.exports = __webpack_public_path__ + "static/media/abbott.ae5c8a9d.png";